import { render, staticRenderFns } from "./clients.html?vue&type=template&id=ccfde654&scoped=true&"
import script from "./clients.js?vue&type=script&lang=js&"
export * from "./clients.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccfde654",
  null
  
)

export default component.exports